(function () {
  var STORAGE_KEY = "maddox_enquiry_customer";

  var FIELDS = [
    { key: "first_name", selector: 'input[autocomplete="given-name"]' },
    { key: "last_name", selector: 'input[autocomplete="family-name"]' },
    { key: "email", selector: 'input[type="email"][name="email"]' },
    { key: "phone", selector: 'input[type="tel"][name="phone-number"]' },
    { key: "address", selector: 'input[autocomplete="address-line1"]' },
    { key: "postcode", selector: 'input[autocomplete="postal-code"]' },
  ];

  function storageAvailable() {
    try {
      var test = "__maddox_storage_test__";
      sessionStorage.setItem(test, test);
      sessionStorage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }

  function loadStored() {
    if (!storageAvailable()) {
      return null;
    }

    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function saveStored(partial) {
    if (!storageAvailable() || !partial) {
      return;
    }

    try {
      var existing = loadStored() || {};
      Object.keys(partial).forEach(function (key) {
        if (partial[key]) {
          existing[key] = partial[key];
        }
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    } catch (error) {
      // Fail silently — form must keep working
    }
  }

  function setReactValue(input, value) {
    var descriptor = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    );

    if (!descriptor || !descriptor.set) {
      input.value = value;
    } else {
      descriptor.set.call(input, value);
    }

    ["input", "change", "blur"].forEach(function (eventName) {
      input.dispatchEvent(new Event(eventName, { bubbles: true }));
    });
  }

  function getEnquiryModal(scope) {
    scope = scope || document;
    return (
      scope.querySelector(
        '[data-modal] .modal__content [data-product-enquiry-modal]'
      ) ||
      scope.querySelector(
        '[data-product-enquiry-modal][data-modal-portal-active="true"]'
      )
    );
  }

  function getKlaviyoForm(modal) {
    if (!modal) {
      return null;
    }

    return (
      modal.querySelector('form[data-testid^="klaviyo-form-"]') ||
      modal.querySelector('[class*="klaviyo-form-"] form')
    );
  }

  function fieldFromInput(input) {
    for (var i = 0; i < FIELDS.length; i++) {
      if (input.matches(FIELDS[i].selector)) {
        return FIELDS[i];
      }
    }
    return null;
  }

  function rehydrateCustomerFields(scope) {
    var modal = getEnquiryModal(scope);
    var form = getKlaviyoForm(modal);
    var stored = loadStored();

    if (!form || !stored) {
      return;
    }

    FIELDS.forEach(function (field) {
      if (!stored[field.key]) {
        return;
      }

      var input = form.querySelector(field.selector);

      if (input && !input.value) {
        setReactValue(input, stored[field.key]);
      }
    });
  }

  function saveFromKlaviyoMeta(meta) {
    if (!meta) {
      return;
    }

    var partial = {};

    if (meta.email) {
      partial.email = meta.email;
    }
    if (meta.phone_number) {
      partial.phone = meta.phone_number;
    }
    if (meta["First Name"]) {
      partial.first_name = meta["First Name"];
    }
    if (meta["Last Name"]) {
      partial.last_name = meta["Last Name"];
    }
    if (meta.Address) {
      partial.address = meta.Address;
    }
    if (meta["Postcode / ZIP Code"]) {
      partial.postcode = meta["Postcode / ZIP Code"];
    }

    saveStored(partial);
  }

  function scheduleRehydrate() {
    [0, 50, 150, 300, 600].forEach(function (delay) {
      window.setTimeout(function () {
        rehydrateCustomerFields(document);
      }, delay);
    });
  }

  document.addEventListener(
    "input",
    function (event) {
      var input = event.target;

      if (!input || !input.matches("input, textarea")) {
        return;
      }

      var form = input.closest('form[data-testid^="klaviyo-form-"]');

      if (!form || !form.closest("[data-product-enquiry-modal]")) {
        return;
      }

      var field = fieldFromInput(input);
      var value = input.value ? input.value.trim() : "";

      if (!field || !value) {
        return;
      }

      var partial = {};
      partial[field.key] = value;
      saveStored(partial);
    },
    true
  );

  document.addEventListener("enquiry-modal:ready", scheduleRehydrate);

  window.addEventListener("klaviyoForms", function (event) {
    if (!event.detail) {
      return;
    }

    if (event.detail.type === "embedOpen") {
      scheduleRehydrate();
      return;
    }

    if (
      event.detail.type === "submit" ||
      event.detail.type === "stepSubmit"
    ) {
      saveFromKlaviyoMeta(event.detail.metaData);
    }
  });

  document.addEventListener("DOMContentLoaded", scheduleRehydrate);
  document.addEventListener("shopify:section:load", scheduleRehydrate);
})();
